import { render, staticRenderFns } from "./pkd-table.vue?vue&type=template&id=3db8b5b4"
import script from "./pkd-table.vue?vue&type=script&lang=js"
export * from "./pkd-table.vue?vue&type=script&lang=js"
import style0 from "./pkd-table.vue?vue&type=style&index=0&id=3db8b5b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports